<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-31 16:50:13
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-22 17:44:28
-->
<template>
	<el-dialog title="规则说明" :visible.sync="dialogVisible" width="400px" :append-to-body="true" :before-close="handleClose">
		<div class="yx-color-text-primary font-h4-regular">
			<slot></slot>
		</div>
		<span slot="footer">
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'ruleExplainDialog',
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
	},
};
</script>

<style lang="less" scoped></style>
